import Layout from '@/views/Layout/index.vue';
import InternalManagement from "@/views/internalManagement"

const Accounting = ()=> import("@/views/internalManagement/Accounting")
const ArrearsManagement = ()=> import("@/views/internalManagement/ArrearsManagement")
const CommodityManagement = ()=> import("@/views/internalManagement/CommodityManagement")
const WarehousingComponent = ()=> import("@/views/internalManagement/CommodityManagement/StockInOutRecords/WarehousingComponent")
const SalaryPerformance = () => import("@/views/internalManagement/SalaryPerformance")
const SalaryDetails = () => import('@/views/internalManagement/SalaryPerformance/PerformanceSettings/SalaryDetails')
export default {
  path: '/internalmanagement',
  component: Layout,
  children: [
    {
			path: '',
      component: InternalManagement,
      children: [

        {
          path: 'accounting',
          component: Accounting,
        }, {
          path: '/internalmanagement/arrearsManagement',
          component: ArrearsManagement,
        },
        {
          path: '/internalmanagement/commodityManagement',
          component: CommodityManagement,
        },{
          path: '/internalmanagement/WarehousingComponent',
          component: WarehousingComponent,
        },{
          path: '/internalmanagement/SalaryPerformance',
          component: SalaryPerformance,
        },{
          path:'/internalmanagement/SalaryDetails',
          component:SalaryDetails
        }
      ]
    }
  ]
}
